import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { tap } from 'rxjs/internal/operators/tap';
import { CacheResolverService } from '../_services/cache-resolver.service';

const TIME_TO_LIVE = 600;

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
    constructor(
        private cacheResolver: CacheResolverService,
        private analytics: AngularFireAnalytics
    ) {}
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // fire base
        this.analytics.setUserId('lokOs');
        this.analytics.setUserProperties({ name: 'network', value: 'api' });
        this.analytics.logEvent('network_api', {
            netwok_api: req.urlWithParams,
        });

        let isFound: any;
        isFound = req.urlWithParams.search('reporting');
        if (isFound < 0) {
            isFound = req.urlWithParams.search('getShgDetailById');
        }
        if (isFound < 0) {
            isFound = req.urlWithParams.search('/member/get');
        }
        if (isFound < 0) {
            isFound = req.urlWithParams.search('/shg/profile/get');
        }
        if (isFound < 0) {
            isFound = req.urlWithParams.search('member/memberAddress');
        }
        if (isFound < 0) {
            return next.handle(req);
        }

        // Check if latestCheckbox is ticked to get new results

        if (req.headers.get('x-refresh')) {
            return this.sendRequest(req, next);
        }
        const cachedResponse = this.cacheResolver.get(req.urlWithParams);

        return cachedResponse
            ? of(cachedResponse)
            : this.sendRequest(req, next);
    }

    sendRequest(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap((event) => {
                if (event instanceof HttpResponse) {
                    this.cacheResolver.set(
                        req.urlWithParams,
                        event,
                        TIME_TO_LIVE
                    );
                }
            })
        );
    }
}
